import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectParkingTypes = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('parking_type')(jsonQuery),
);
